module.exports = __webpack_public_path__ + "static/media/qr-code.892a560c.svg";